module.exports = {
    LOADERS: [
        'spinner',
        'dots',
        'bars',
    ],
    DefaultLoader: 'spinner',
};
